import React from "react";
// @ts-ignore
import { Link as RouterLink } from "react-router-dom";
import Constants from "../../../data/Constants";
import Images from "../../../assets/images/Images";

const BackIconComponent: React.FC = () => {
    return (
        <RouterLink to={Constants.routes.economicResearch} className='backLink'>
            <div style={{flex: 1}}>
                <img src={Images.expand} style={{height: 35, transform: 'rotate(90deg)'}} alt='Back Button'/>
            </div>
            <div style={{flex: 1, margin: "auto"}}>HOME</div>
        </RouterLink>
    )
};

export default BackIconComponent;